import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Row } from "react-bootstrap";
import Package from "../Package/Package";

const Packages = () => {
  const [packages, setPackages] = useState([]);

  useEffect(() => {
    axios
      .get("https://maiden-tourism-server.vercel.app/packages")
      .then(({ data }) => setPackages(data));
  }, []);

  return (
    <Container id="packages" className="py-5">
      <h1 className="py-4 display-4">Packages</h1>
      <Row className="justify-content-center mt-4">
        {packages.map((pkg) => (
          <Package pckg={pkg} key={pkg._id}></Package>
        ))}
      </Row>
    </Container>
  );
};

export default Packages;
